<template>
    <v-layout class="fleet-container" column>             
       <v-tabs v-if="!isFleetListPage" align-with-title slider-color="#ddd">        
        <v-tab class="fleettab" exact :to="'/pilot/fleet/'+fleet.FLE_ID" v-for="{fleet} in detailFleets" :key="fleet.FLE_ID">          
          <fleet-state :fleet="fleet" class="pr-2" />
          {{ fleet.FLE_LIBELLE }}  
          <v-spacer /><v-btn class="mr-0" small icon @click.prevent.stop="$store.myActions.FLEET_UNSELECT_DETAIL(fleet.FLE_ID)" :title="$t('Pilot.FleetInfos.CloseFleetTabTooltip')"><v-icon small>mdi-close</v-icon></v-btn>
        </v-tab>
        <v-tab class="fleetmore" exact to="/pilot/fleet" :title="$t('Pilot.FleetInfos.AddFleetTabTooltip')"><v-icon>mdi-plus</v-icon></v-tab>
        <v-spacer />
        <v-tab exact to="/fleet">{{$t('Pilot.FleetInfos.BackToMap')}}</v-tab>
      </v-tabs>      
      <router-view/>     
    </v-layout>
</template>
<script lang="ts">
  import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import { FleetUi } from '../../models/ui/FleetUi'
import FleetState from '@/components/fleet/FleetState.vue'
import types from '@/store/all-mutation-types'
  
  @Component({
    name: 'Fleet',
    components:{FleetState}
  })
  export default class Fleet extends Vue {             

    // BLF037 — module Gestion de flotte accessible (RG-ACC-051), pour /fleet comme /pilot/fleet ;
    // un rôle multi-enseignes attend la liste des enseignes avant de décider.
    beforeRouteEnter(to:any,from:any,next:any) {
      next((vm:Fleet) => {
        const store = vm.$store
        const check = () => {
          if (!store.myGetters.hasFleetModule) vm.$router.replace('/')
        }
        if (store.myGetters.isMultiTenantRole) store.dispatch(types.ENSEIGNE_ENSURE_LIST).catch(() => {}).finally(check)
        else check()
      })
    }

    // BLF037 — onglets des seules flottes autorisées pour leur enseigne (RG-ACC-050).
    get detailFleets(){
      return this.$store.myGetters.detailFleets.filter((fu: FleetUi) => this.$store.myGetters.isFleetAllowed(fu.fleet))
    }

    get isFleetListPage(){
      return this.$route.name == 'Fleet'
    }

    @Watch('detailFleets')
    onDetailFleetsChanged(newValue: Array<FleetUi>, oldValue: Array<FleetUi>) {      
      //si l'onglet fermé est l'onglet en cours on navigue sur la page précédente        
        if(this.$route.params.fleetid && 
          newValue.findIndex(it => it.fleet.FLE_ID == parseInt(this.$route.params.fleetid)) == -1
        ) {          
          this.$router.push('/fleet/'+(newValue.length > 0?newValue[0].fleet.FLE_ID:""))
        }  
    }
    
  }
</script>

<style scoped>
  .fleet-container{    
    position: absolute;
    top: 0; bottom: 0; left: 0; right: 0;
    overflow: hidden;
  }
  .fleettab, .fleetmore{
    border-right:1px solid #efefef;
  }
  .fleettab  .v-tabs__item{
    padding-right: 0;
  }   
  
</style>

<style>
  .fleettab .v-tabs__item--active,.fleetmore .v-tabs__item--active{
    background-color:#ddd;
  }
  
</style>
